import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Icon from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Icon';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundButton from 'Components/UI/RoundButton';
import StyledTooltip from 'Components/UI/StyledTooltip';
import Typography from 'Components/UI/Typography';
import { clientPaths } from 'Consts/Strings';
import GoalsIcon from 'Icons/Goals';
import DoneIcon from '@material-ui/icons/Done';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  rootHidden: {
    display: 'none',
  },
  title: {
    paddingRight: theme.spacing(2),
  },
  button: {
    marginBottom: theme.spacing(2),
  },
});

const GoalTools = ({
  className,
  classes,
  goalResource,
}) => {
  const { rootNodeProps, logResourceEvent } = useEventTrackingLogEvent({ nodeName: 'Goal Tools' });
  const flowComplete = goalResource.attr('flowStatus') === 'complete';
  const tools = [
    {
      hidden: !goalResource.relationship('flow'),
      status: goalResource.attr('flowStatus'),
      text: 'Tell us more',
      tooltip: flowComplete ? 'Steps have been completed' : 'Enter more detailed information',
      icon: flowComplete ? DoneIcon : GoalsIcon,
      iconFill: flowComplete ? 'secondary' : 'accentBlue',
      to: () => {
        logResourceEvent('Client Goals Page: Clicked Tell us more button on Goal', goalResource);
        const urlSearchParams = new URLSearchParams();

        urlSearchParams.set('link', goalResource.relationship('flow').link('related').url());

        return {
          pathname: clientPaths.flow,
          search: urlSearchParams.toString(),
        };
      },
    },
  ].filter(v => !v.hidden);

  return (
    <div
      {...rootNodeProps}
      className={classNames(classes.root, className, {
        [classes.rootHidden]: tools.length === 0,
      })}
    >
      <Typography
        className={classes.title}
        color="primary"
        variant="h1"
      >
        {'Tools'}
      </Typography>
      {tools.map((tool) => {
        const IconComponent = tool.icon;

        return (
          <StyledTooltip
            arrow
            color="accentBlue"
            variant="rounded"
            title={tool.tooltip}
          >
            <RoundButton
              color="white"
              component={Link}
              variant="contained"
              startIcon={
                <Icon
                  fill={tool.iconFill}
                  icon={IconComponent}
                  stroke={tool.iconStroke}
                />
              }
              to={(typeof tool.to === 'function') ? tool.to() : tool.to}
            >
              {tool.text}
            </RoundButton>
          </StyledTooltip>
        );
      })}
    </div>
  );
};

GoalTools.defaultProps = {
  className: '',
};

GoalTools.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  goalResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(GoalTools);
